import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { signIn, setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(location.hash.slice(1)).get("session_id");
    api.post("/auth/session", { session_id: sid })
      .then(({ data }) => {
        signIn(data);
        nav(data.is_new ? "/muses/new" : "/", { replace: true });
      })
      .catch(() => { setUser(false); nav("/login", { replace: true }); });
  }, [location.hash, nav, signIn, setUser]);

  return <div className="min-h-screen" data-testid="auth-callback" />;
}
